// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../../../components/Layout/Footer';
import Layout from '../../../../../../components/Layout/Layout';
import Main from '../../../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../../../components/Layout/PageHeader';
import AddCompany from '../../../../../../components/AddNewCompany/AddCompany';
import { ProgressIndicator, useLink } from '../../_config';
import useFormikOrchestration from '~/components/useFormikOrchestration';
import useUrlQuery from '~/components/useUrlQuery';

export default function AddCompanyPage({ match }) {
  const history = useHistory();
  const link = useLink('suppliers');
  const { supplierName } = match?.params;
  const { triggerSubmit, setFormikContext, isValid } = useFormikOrchestration();
  const initialValues = useUrlQuery();
  return (
    <Layout>
      <ProgressIndicator step="matchSuppliers" />
      <PageHeader>
        <PageTitle>
          <Trans>Add producer</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Matching "{supplierName}"</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <AddCompany
          initialValues={initialValues}
          onInviteCompany={(companyData) => {
            const url = link._all.searchCompany({ companyData, supplierName });
            history.push(url);
          }}
          setFormikContext={setFormikContext}
        />
      </Main>
      <Footer>
        <BackButton to={link._all.supplier({ supplierName })} />
        <CancelButton to={link.cancel()} />
        <NextButton onClick={triggerSubmit} disabled={!isValid}>
          <Trans>Add</Trans>
        </NextButton>
      </Footer>
    </Layout>
  );
}
